module.exports = __webpack_public_path__ + "static/media/probaEnem.b5d6b012.png";